import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="innovativeimg">
                                                    <img alt=""
                                                         src={require('@images/How to manage difficult conversations.png')}/>
                                                </div>

                                                <div className="ilead-contentarea">

                                                    <div className="circle_title"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>isn't it interesting?</div>
                                                    <div className="border_subtitle">Raise your hand</div>
                                                    <p>Think back to your school days when you’re in a class with your
                                                        teacher and he or she asks your class a particularly difficult
                                                        question and you have to put your hand up if you think the
                                                        answer is a), b) or c). How many people would make up their mind
                                                        independently and how many would base their decision on what
                                                        other people say? In 1956, Solomon Asch conducted experiments
                                                        into conformity.<a className="superscripttext"
                                                                           href="further_info.php?course=300"><sup>1</sup></a>
                                                    </p>

                                                    <div className="lightgreencontentbg keyquestionpad image-float">
                                                        <div className="border_subtitle">Have you got the measure?</div>
                                                        <p>Asch asked groups of people to vote out loud on which line
                                                            was the same length as the one on the left.</p>
                                                        <img
                                                            src={require('@images/image-team.jpg')}
                                                            alt="" style={{float: 'left',paddingRight: '10px'}}/>
                                                            <p>In each group there was one real participant and several
                                                                stooges who had been told to give the obviously
                                                                incorrect answer ‘a’. Shockingly, 75% of people went
                                                                along with the majority vote on at least one occasion
                                                                despite the answer being clearly wrong. When questioned
                                                                as to why they did this, participants explained a
                                                                ‘pressure’ to conform.</p>
                                                            <p>This has been demonstrated in more modern settings, for
                                                                example in a mock-jury activity<a
                                                                    className="superscripttext"
                                                                    href="further_info.php?course=300"><sup>2</sup></a> participants
                                                                were required to pass judgement on how much a widow of a
                                                                farmer should inherit from his estate instead of his
                                                                sister. When individually asked, around 70% gave her
                                                                less than half of the estate; however, when placed in a
                                                                jury, the joint decision increased this to more than
                                                                95%. This is a clear case of a majority causing the
                                                                minority to conform, leading to a skewed decision.</p>
                                                    </div>

                                                    <div className="right-btn"><div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}